<template>
    <div class="antialiased font-sans bg-gray-200">

        <div class="flex flex-wrap w-full justify-center md:justify-between items-center
        py-3 bg-white shadow-lg">
            <div class="flex ml-0 md:ml-6 cursor-pointer pr-4 items-center" @click="goBack">
                <img alt="school logo" class="h-10 w-10" src="../../images/gciosa.png">
                <span class="ml-1 text-xl text-white text-blue-900 font-semibold invisible md:visible">GCIOSA</span>
            </div>

            <ul class="md:flex sm:block mt-6 md:mt-0 ml-6 md:ml-0 overflow-x-auto mr-0 md:mr-10 font-semibold pt-0 md:pt-2">

                <li class="mb-2 px-4 py-1 bg-white border-red-900 hover:bg-red-900 rounded-lg text-red-900 hover:text-white"
                    style="border-width: 1px">
                    <a @click="logout" class="text-sm">Logout</a>
                </li>

            </ul>
        </div>


        <div class="container mx-auto px-4 sm:px-8">
            <div class="py-8">
                <div>
                    <h2 class="text-2xl font-semibold leading-tight">Admins</h2>
                </div>
                <div class="my-2 flex sm:flex-row flex-col">

                    <!--                <div class="flex flex-row mb-1 sm:mb-0">-->
                    <!--                    <div class="relative">-->
                    <!--                        <select-->
                    <!--                            class="appearance-none h-full rounded-l border block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">-->
                    <!--                            <option>5</option>-->
                    <!--                            <option>10</option>-->
                    <!--                            <option>20</option>-->
                    <!--                        </select>-->
                    <!--                        -->
                    <!--                        <div-->
                    <!--                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">-->
                    <!--                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">-->
                    <!--                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />-->
                    <!--                            </svg>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div class="relative">-->
                    <!--                        <select-->
                    <!--                            class="appearance-none h-full rounded-r border-t sm:rounded-r-none sm:border-r-0 border-r border-b block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:border-l focus:border-r focus:bg-white focus:border-gray-500">-->
                    <!--                            <option>All</option>-->
                    <!--                            <option>Active</option>-->
                    <!--                            <option>Inactive</option>-->
                    <!--                        </select>-->
                    <!--                        <div-->
                    <!--                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">-->
                    <!--                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">-->
                    <!--                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />-->
                    <!--                            </svg>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                </div>-->

                    <div class="flex flex-row w-full md:w-2/3 bg-white rounded border border-gray-400  py-2">
                    <span class="inset-y-0 left-0 flex items-center pl-2">
                        <svg viewBox="0 0 24 24" class="h-4 w-4 fill-current text-gray-500">
                            <path
                                d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z">
                            </path>
                        </svg>
                    </span>
                        <input placeholder="Search" v-model="searchWord"  @keyup.enter="searchUsers"
                               class="appearance-none pl-8 pr-6 block w-full text-sm placeholder-gray-400 text-gray-700 focus:bg-white focus:placeholder-gray-600 focus:text-gray-700 focus:outline-none" />
                    </div>

                    <!-- <div class="h-10">
                        <vue-loaders v-if="searchLoading" name="ball-spin-fade-loader" scale="0.5" color="#2a4365"
                                        class="inline-block px-3 py-1 mt-3 md:ml-3 md:mt-0" style="border-width: 10px">
                        </vue-loaders>
                     </div> -->

                </div>

                <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                    <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">
                        <table class="min-w-full leading-normal">
                            <thead>
                                <tr>
                                    <th
                                        class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                        Name
                                    </th>
                                    <th
                                        class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                        Gender
                                    </th>
                                    <th
                                        class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                        Phone number
                                    </th>
                                    <th
                                        class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                        Email
                                    </th>

                                    <th
                                        class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">

                                    </th>
                                </tr>
                            </thead>

                            <div  v-if="loading" class="flex">
                                <div class=" mx-auto">
                                    <!-- <img alt="school logo" class="object-contain h-10 w-20" src="../images/loading.gif"> -->
                                    <vue-loaders
                                    name="ball-spin-fade-loader" color="#2a4365" class="mx-auto my-4" scale="1"></vue-loaders>
                                </div>
                            
                            </div>


                            <tbody v-if="!loading && admins.length > 0">
                                <tr v-for="(admin, index) in admins" :key="index" class="bg-white hover:bg-gray-200">
                                    <td class="px-5 py-5 border-b border-gray-200 text-sm">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 w-24 h-24">
                                                <img class="w-full h-full rounded-full"
                                                    :src="admin.image_url"
                                                    :alt="admin.first_name" />
                                                    <!-- <UserIcon class="w-full h-full rounded-full"></UserIcon> -->
                                            </div>
                                            <div class="ml-3">
                                                <p class="text-gray-900 whitespace-no-wrap capitalize">
                                                    {{admin.title}} {{admin.first_name}} {{admin.last_name}} {{admin.other_name || ''}}
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="px-5 py-5 border-b border-gray-200 text-sm">
                                        <p class="text-gray-900 capitalize whitespace-no-wrap">{{admin.gender}}</p>
                                    </td>
                                    <td class="px-5 py-5 border-b border-gray-200 text-sm">
                                        <p class="text-gray-900 whitespace-no-wrap">
                                            {{admin.phone_number}}
                                        </p>
                                    </td>
                                    <td class="px-5 py-5 border-b border-gray-200 text-sm">
                                        <p class="text-gray-900 whitespace-no-wrap">
                                            {{admin.email}}
                                        </p>
                                    </td>

                                    <td class="px-5 py-5 border-b border-gray-200 text-sm">



                                        <button @click="viewUser(admin.id)"
                                                class="relative inline-block px-4 py-2 mr-3 rounded font-semibold text-green-900 bg-green-200
                                        hover:text-white hover:bg-green-900 leading-tight shadow">
                                            <span aria-hidden
                                                class="absolute inset-0 opacity-50"></span>
                                            <span class="relative">View</span>
                                        </button>

                                        <button @click="revokeAdmin(admin.id, `${admin.first_name} ${admin.last_name}`)"
                                            class="relative inline-block px-4 py-2 ml-0 lg:ml-3 rounded font-semibold text-red-900 bg-red-200
                                        hover:text-white hover:bg-red-900 leading-tight mt-3 lg:mt-0 shadow">
                                            <span aria-hidden
                                                class="absolute inset-0 opacity-50"></span>
                                            <span class="relative">Revoke admin</span>
                                        </button>

                                        <!--badge component-->
                                        <!--                                <span-->
                                        <!--                                    class="relative inline-block px-3 py-1 font-semibold text-red-900 leading-tight">-->
                                        <!--                                        <span aria-hidden-->
                                        <!--                                              class="absolute inset-0 bg-red-200 opacity-50 rounded-full"></span>-->
                                        <!--                                        <span class="relative">Delete</span>-->
                                        <!--                                    </span>-->
                                    </td>

                                </tr>

                            </tbody>
                        </table>
                        <div
                            class="px-5 py-5 bg-white border-t flex flex-col xs:flex-row items-center xs:justify-between">
                        <span class="text-xs xs:text-sm text-gray-900">
                            Showing {{pagination.from || 0}} to {{pagination.to || 0}} of {{pagination.total || 0}} Entries
                        </span>
                            <div class="inline-flex mt-2 xs:mt-0">

                                <button v-if="pagination.current_page > 1" @click="fetchUsers(pagination.prev_page_url)"
                                        class="text-sm bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-l">
                                    Prev
                                </button>
                                <button v-if="pagination.current_page < pagination.last_page" @click="fetchUsers(pagination.next_page_url)"
                                        class="text-sm bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-r">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios';
    // import {UserIcon} from 'vue-feather-icons';

    export default {
        name: "Admins",
        // components: {UserIcon},
        data: function(){
            return {
                searchWord: null,
                admins: [],
                pagination: {},
                searchLoading: false,
                loading: false,
            };
        },
        methods: {

            fetchUsers(page_url){
                this.loading = true;
                page_url = page_url || '/api/admins';
                let token = localStorage.getItem('token');
                Axios.get(page_url,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    }).then(response => {
                        if(this.searchWord !== '') this.searchLoading = false;
                        this.loading = false;
                    if(response.data.status === true){
                        this.admins = response.data.data.data;
                        this.makePagination(response.data.data)
                    }
                });

            },

            makePagination(data){
                this.pagination = {
                    current_page: data.current_page,
                    last_page: data.last_page,
                    first_page_url: data.first_page_url,
                    next_page_url: data.next_page_url,
                    prev_page_url: data.prev_page_url,
                    from: data.from,
                    to: data.to,
                    total: data.total,
                };

            },

            searchUsers(){
                if(this.searchWord != null && this.searchWord.length > 0){
                    this.searchLoading = true;
                    this.fetchUsers(`/api/admins?search=${this.searchWord}`);
                }else{
                    this.$swal({
                        toast: true,
                        title: 'Search field can\'t be empty',
                        showConfirmButton: false,
                        timer: 1500,
                        position: 'top-end',
                    });
                }
            },

            revokeAdmin(id, name){
                this.$swal({
                    // title: "Are you sure?",
                    text: `Are you sure you want to revoke ${name}'s admin right?`,
                    // icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                    let token = localStorage.getItem("token");
                    return Axios.patch(`/api/users/${id}`, 
                        {
                            "user_type": "user"
                        },
                        {
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                            }
                        }).then(response => {
                        // this.$swal.stopLoading();
                            if (response.data.status === true) {
                            this.admins = response.data.data.data;
                            this.makePagination(response.data.data)
                            this.$swal("Success!", `${name} is no longer an admin`, "success");
                            } else {
                            this.$swal("Please login");
                            this.$router.push("/");
                            }
                        });
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                });
            },

            viewUser(id){
                this.$router.push(`/users/${id}`)
            },

            logout(){
                this.$router.push('/');
            },
            goBack(){
                this.$router.back();
            }

        },
        created() {
            this.fetchUsers();
        },
        watch: {
            searchWord: function(val){
                if(val === '' || val.length < 1){
                    this.fetchUsers();
                }
            }
        }
    }
</script>

<style scoped>

</style>
